module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kb-search"
  }, [_c('div', {
    staticClass: "panel h1-panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h1', [_c('router-link', {
    attrs: {
      "to": "/kb"
    }
  }, [_vm._v("Knowledge Base")])], 1)]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('section', {
    staticClass: "panel search-panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('h2', [_vm._v("Search")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.search()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search for a topic (lighting, texturing, ...)"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('button', {
    staticClass: "link-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleFilters()
      }
    }
  }, [(!_vm.filtersShowing) ? _c('span', [_vm._v("Show Filters")]) : _c('span', [_vm._v("Hide Filters")])])])])]), _vm._v(" "), (_vm.filtersShowing) ? _c('section', {
    staticClass: "panel filter-panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('h2', [_vm._v("Filters")]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "loading-msg"
  }, [_vm._v("\n                Loading...\n            ")]) : _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.search()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Category")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.categoryOptionsAsLabels
    },
    model: {
      value: (_vm.categories),
      callback: function($$v) {
        _vm.categories = $$v
      },
      expression: "categories"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Term Type")]), _vm._v(" "), _c('multiselect', {
    staticClass: "term-type-multiselect",
    attrs: {
      "options": _vm.termTypeOptions
    },
    model: {
      value: (_vm.termTypes),
      callback: function($$v) {
        _vm.termTypes = $$v
      },
      expression: "termTypes"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Path")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.pathOptionsAsNames
    },
    model: {
      value: (_vm.paths),
      callback: function($$v) {
        _vm.paths = $$v
      },
      expression: "paths"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Software")]), _vm._v(" "), _c('software-select', {
    attrs: {
      "options": _vm.softwareOptions
    },
    model: {
      value: (_vm.software),
      callback: function($$v) {
        _vm.software = $$v
      },
      expression: "software"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tags")]), _vm._v(" "), _c('tag-select', {
    attrs: {
      "search": _vm.searchTags
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "panel results-panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "loading-msg"
  }, [_vm._v("\n                Loading...\n            ")]) : (_vm.isSearching) ? _c('div', {
    staticClass: "loading-msg"
  }, [_vm._v("\n                Searching...\n            ")]) : _c('div', [(_vm.results.length > 0) ? _c('div', [_c('h2', [_vm._v(_vm._s(_vm.formatSearchArticlesTitle(_vm.results)))]), _vm._v(" "), _c('ol', _vm._l((_vm.results), function(article) {
    return _c('li', [_c('kb-block-link', {
      staticClass: "article-block",
      attrs: {
        "to": _vm.getArticleLocation(article)
      }
    }, [_c('div', {
      staticClass: "article-overview"
    }, [(_vm.getCoverImageUrl(article)) ? _c('img', {
      attrs: {
        "src": _vm.getCoverImageUrl(article)
      }
    }) : _c('img', {
      attrs: {
        "src": require("../assets/img/ttto-thumbnail.jpg")
      }
    }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(article.title))]), _vm._v(" "), (article.overviewHighlights) ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(article.overviewHighlights)
      }
    }) : _c('p', {
      domProps: {
        "innerHTML": _vm._s(article.overview)
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.doesArticleHaveAnySearchInfo(article)),
        expression: "doesArticleHaveAnySearchInfo(article)"
      }],
      staticClass: "article-search-info"
    }, [_c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.doesArticleHaveSearchHighlights(article)),
        expression: "doesArticleHaveSearchHighlights(article)"
      }],
      staticClass: "article-quotes"
    }, _vm._l((article.search.highlights), function(hl) {
      return _c('li', [_c('blockquote', {
        domProps: {
          "innerHTML": _vm._s(hl)
        }
      })])
    })), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.doesArticleHaveSearchDetails(article)),
        expression: "doesArticleHaveSearchDetails(article)"
      }],
      staticClass: "article-details"
    }, [(article.search.software.length > 0) ? _c('div', {
      staticClass: "info-group"
    }, [_c('div', {
      staticClass: "info-group-label"
    }, [_vm._v("Software")]), _vm._v(" "), _c('software-list', {
      attrs: {
        "value": article.search.software
      }
    })], 1) : _vm._e(), _vm._v(" "), (article.search.tags.length > 0) ? _c('div', {
      staticClass: "info-group"
    }, [_c('div', {
      staticClass: "info-group-label"
    }, [_vm._v("Tags")]), _vm._v(" "), _c('tag-list', {
      attrs: {
        "value": article.search.tags
      }
    })], 1) : _vm._e(), _vm._v(" "), (article.search.categories.length > 0) ? _c('div', {
      staticClass: "info-group"
    }, [_c('div', {
      staticClass: "info-group-label"
    }, [_vm._v("Categories")]), _vm._v(" "), _c('option-list', {
      attrs: {
        "value": article.search.categories
      }
    })], 1) : _vm._e(), _vm._v(" "), (article.search.termTypes.length > 0) ? _c('div', {
      staticClass: "info-group"
    }, [_c('div', {
      staticClass: "info-group-label"
    }, [_vm._v("Term Types")]), _vm._v(" "), _c('option-list', {
      attrs: {
        "value": article.search.termTypes
      }
    })], 1) : _vm._e(), _vm._v(" "), (article.search.paths.length > 0) ? _c('div', {
      staticClass: "info-group"
    }, [_c('div', {
      staticClass: "info-group-label"
    }, [_vm._v("Paths")]), _vm._v(" "), _c('option-list', {
      attrs: {
        "value": article.search.paths
      }
    })], 1) : _vm._e()])])])], 1)
  }))]) : _c('div', {
    staticClass: "no-results"
  }, [_c('h2', [_vm._v(_vm._s(_vm.formatSearchArticlesTitle(_vm.results)))])])])])]), _vm._v(" "), _c('kb-feedback')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-body"
  }, [_c('h2', [_vm._v("Search")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "clear-button",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-28726389!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KbSearch.vue
// module id = 1978
// module chunks = 2